import PropTypes from 'prop-types';

export const VALUE_TYPE_PERCENTAGE = 'percentage';
export const VALUE_TYPE_MONEY = 'money';
export const VALUE_TYPE_NUMBER = 'number';
export const VALUE_TYPE_TEXT = 'text';
export const VALUE_TYPE_BOOLEAN = 'boolean';

export const createSetting = (label, valueType, value = 0) => ({
  label,
  valueType,
  value,
});

export const settingShape = {
  [PropTypes.string]: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    valueType: PropTypes.oneOf([
      VALUE_TYPE_PERCENTAGE,
      VALUE_TYPE_MONEY,
      VALUE_TYPE_BOOLEAN,
    ]),
  }),
};
